// removed by extract-text-webpack-plugin
module.exports = {"childContainer":"Tooltip__childContainer","textInfo":"Tooltip__textInfo","bgwhite":"Tooltip__bgwhite","infoBox":"Tooltip__infoBox","arrow":"Tooltip__arrow","show":"Tooltip__show","positionBottom":"Tooltip__positionBottom","positionTop":"Tooltip__positionTop","rel-pmt":"Tooltip__rel-pmt","relPmt":"Tooltip__rel-pmt"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Tooltip/Tooltip.scss
// module id = 651
// module chunks = 8